<style scoped lang="stylus" rel="stylesheet/stylus">
.container
  background #f2f2f2
  min-height 100%
</style>

<template>
	<div class="container">
		<div class="area-box">
			当前省市区:{{ nowAreaName }}
			<van-button @click="toggleArea">修改</van-button>
		</div>
		<div class="weather-category">
			<div class="title">实时天气</div>
			<div class="content">
				<div class="item-box">
					<div class="name">省份名</div>
					<div class="value">{{ lives.province }}</div>
				</div>
				<div class="item-box">
					<div class="name">城市名</div>
					<div class="value">{{ lives.city }}</div>
				</div>
				<div class="item-box">
					<div class="name">区域编码</div>
					<div class="value">{{ lives.adcode }}</div>
				</div>
				<div class="item-box">
					<div class="name">天气现象</div>
					<div class="value">{{ lives.weather }}</div>
				</div>
				<div class="item-box">
					<div class="name">实时气温</div>
					<div class="value">{{ lives.temperature }}</div>
				</div>
				<div class="item-box">
					<div class="name">风向描述</div>
					<div class="value">{{ lives.winddirection }}</div>
				</div>
				<div class="item-box">
					<div class="name">风力级别</div>
					<div class="value">{{ lives.windpower }}</div>
				</div>
				<div class="item-box">
					<div class="name">空气湿度</div>
					<div class="value">{{ lives.humidity }}</div>
				</div>
				<div class="item-box">
					<div class="name">发布时间</div>
					<div class="value">{{ lives.reporttime }}</div>
				</div>
			</div>
		</div>
		<van-popup
			v-model="isAreaShow"
			position="bottom"
			:close-on-click-overlay="false"
			@click-overlay="resetArea"
		>
			<van-area
				ref="area"
				title="省市区"
				:area-list="areaList"
				:value="nowAreaCode"
				@cancel="resetArea"
				@confirm="confirmArea"
			/>
		</van-popup>
	</div>
</template>

<script>
import { areaList } from '@vant/area-data'
export default {
	name: 'example',
	components: {},
	props: {},
	filters: {},
	computed: {},
	data() {
		return {
			lives: {},
			forecast: {},
			areaList,
			isAreaShow: false,
			nowAreaName: this.$common.getStorage('nowAreaName')
				? this.$common.getStorage('nowAreaName')
				: '北京市-北京市-东城区',
			nowAreaCode: this.$common.getStorage('nowAreaCode') ? this.$common.getStorage('nowAreaCode') : '110101'
		}
	},
	methods: {
		// 获取高德天气
		async getWeatherInfo(type = 'lives') {
			let data = {
				city: this.nowAreaCode,
				key: '767a167ca9e78c99d42482e29e533cbb',
				extensions: type === 'forecast' ? 'all' : 'base'
			}
			let res = await this.$http.getWeatherInfo(data)
			if (type === 'forecast') {
				if (res.status === '1' && res.forecasts) {
					console.log('getWeatherInfo', res)
					// let weatherInfo = [];
					// [weatherInfo[0], weatherInfo[1]] = res.forecasts[0].casts;
					// this.proWeatherInfo(weatherInfo);
					// this.cards.Weather.data = weatherInfo;
					// this.cards.Pollution.data.weatherInfo = weatherInfo[0];
				}
			} else {
				console.log('getWeatherInfo', res)
				this.lives = res.lives[0]
			}
		},
		toggleArea() {
			this.isAreaShow = !this.isAreaShow
		},
		resetArea() {
			this.$refs.area.reset(this.nowAreaCode)
			this.toggleArea()
		},
		confirmArea(areaArr) {
			console.log('areaArr', areaArr)
			this.nowAreaCode = areaArr[2].code
			this.nowAreaName = `${areaArr[0].name}-${areaArr[1].name}-${areaArr[2].name}`
			this.$common.setStorage('nowAreaCode', this.nowAreaCode)
			this.$common.setStorage('nowAreaName', this.nowAreaName)
			this.toggleArea()
			this.getWeatherInfo()
		}
	},
	created() {},
	mounted() {
		this.getWeatherInfo() // 获取实时天气
		console.log('areaList', this.areaList)
	}
}
</script>
